import {
  Favorite,
  ForkRight,
  Group,
  Insights,
  MonitorHeart,
} from '@mui/icons-material';
import { Box, styled } from 'components';
import React, { useContext } from 'react';
import {
  Outlet,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { RetentionNavigation } from '../../../../components/Retention/components/RetentionNavigation';
import { RetentionContext } from '../../../../components/Retention/utils';
import { entryStyles } from '../../../../styles/Retention/Brand';
import { getRoutes } from '../../../../utils';

const {
  ALLOW_RETENTION_BRAND_HEALTH,
  ALLOW_RETENTION_BRAND_PULSE,
  ALLOW_RETENTION_BRAND_PATH,
} = process.env;

const StyledBox = styled(Box)(entryStyles);

const BrandEntry = () => {
  // duplicating this between location and brand because
  // we may want some additional content on each of these
  // dashboards down the line.
  const ctx = useContext(RetentionContext);
  const navigate = useNavigate();
  const routes = getRoutes();
  const location = useLocation();
  const isLocation = location.pathname.indexOf('location') >= 0;

  const healthDashboard = `${routes.employer.retention_portal.brand}/${ctx.retentionPages.health}`;
  const pathDashboard = `${routes.employer.retention_portal.brand}/${ctx.retentionPages.path}`;
  const pulseDashboard = `${routes.employer.retention_portal.brand}/${ctx.retentionPages.pulse}`;
  const workforceDashboard = `${routes.employer.retention_portal.brand}/${ctx.retentionPages.workforce}`;

  return !isLocation ? (
    <StyledBox>
      <Box className="retention-navigation">
        <RetentionNavigation
          buttons={[
            {
              disabled:
                ALLOW_RETENTION_BRAND_PATH === 'false' ||
                location.pathname === pathDashboard,
              label: 'Brand Path Dashboard',
              onClick: () => navigate(pathDashboard),
              testId: 'navigate-to-brand-path-dashboard',
              Icon: ForkRight,
              selected: location.pathname === pathDashboard,
            },
            {
              disabled:
                ALLOW_RETENTION_BRAND_PULSE === 'false' ||
                location.pathname === pulseDashboard,
              label: 'Brand Pulse Dashboard',
              onClick: () => navigate(pulseDashboard),
              testId: 'navigate-to-brand-pulse-dashboard',
              Icon: MonitorHeart,
              selected: location.pathname === pulseDashboard,
            },
            {
              disabled:
                ALLOW_RETENTION_BRAND_HEALTH === 'false' ||
                location.pathname === healthDashboard,
              label: 'Brand Health Dashboard',
              onClick: () => navigate(healthDashboard),
              testId: 'navigate-to-brand-health-dashboard',
              Icon: Favorite,
              selected: location.pathname === healthDashboard,
            },
            {
              disabled: false,
              label: 'Brand Workforce Dashboard',
              onClick: () => navigate(workforceDashboard),
              testId: 'navigate-to-brand-workforce-dashboard',
              Icon: Group,
              selected: location.pathname === workforceDashboard,
            },
            {
              disabled: false,
              label: 'Brand Metrics',
              onClick: () =>
                window.open(
                  'https://metabase.worktorch.io/dashboard/2-employee-dashboard',
                ),
              testId: 'navigate-to-brand-metabase',
              Icon: Insights,
              selected: false,
            },
          ]}
        />
      </Box>
      <Outlet />
    </StyledBox>
  ) : (
    <Outlet />
  );
};

export default BrandEntry;
